import { fetchData } from '@/utils/fetch'
import { usePlugin } from '@/hooks/usePlugin'

const coupon = ref(null)

/**
 * 处理 满减券 相关逻辑
 */
export function useCoupon () {
  const { $toast } = usePlugin()
  const isInvaliding = ref(false)

  const initCoupon = async () => {
    const { code, data } = await fetchData('/appb/b2b/coupon/getUsable')
    if (code === 200) {
      coupon.value = data
    }
  }

  const invalidateCoupon = async (couponCode) => {
    if (isInvaliding.value) return
    isInvaliding.value = true
    const { code, msg } = await fetchData('/appb/b2b/coupon/invalid', {
      method: 'POST',
      body: JSON.stringify({ couponCode })
    })
    if (code === 200) {
      initCoupon()
    } else {
      $toast(msg, { type: 'error' })
    }
    isInvaliding.value = false
  }

  return { initCoupon, coupon, invalidateCoupon }
}
